import { Block } from 'ui-kit/blocks'
import { Heading } from 'ui-kit/typography'
import { LINKS } from 'routes/constants'
import { Link } from 'ui-kit/actions/link/Link'
import { ScenariosCard } from 'routes/components/Features/ScenarioCard'
import { ScenarioTemplateCompact } from 'routes/Scenarios/helpers/types'
import clsx from 'clsx'
import classes from './SolutionScenarios.module.scss'

const INITIAL_SCENARIOS_COUNT = 6

export function SolutionScenarios({
  scenarios,
  scenariosTag,
}: {
  scenarios: ScenarioTemplateCompact[]
  scenariosTag: string | undefined
}) {
  if (!scenarios?.length || !scenariosTag) {
    return null
  }

  const isMoreScenariosAvailable = scenarios.length > INITIAL_SCENARIOS_COUNT

  const visibleScenarios = scenarios.slice(0, INITIAL_SCENARIOS_COUNT)

  const scenariosPageLink = `${LINKS.SCENARIOS}?tag=${scenariosTag}`

  return (
    <Block
      as={'section'}
      variant={'solidMob'}
      pad={'baseMob'}
      divider={'mobile'}
      className={classes.section}
    >
      <Heading as={'h2'} size={'xl'} center>
        Specific Scenarios
      </Heading>

      <ul className={clsx(classes.list)}>
        {visibleScenarios.map((scenario) => (
          <SpecificScenariosCard key={scenario.key} scenario={scenario} />
        ))}
      </ul>

      {isMoreScenariosAvailable && (
        <Link
          className={classes.link}
          type='secondary'
          href={scenariosPageLink}
          target='_self'
        >
          Explore all scenarios
        </Link>
      )}
    </Block>
  )
}

const SpecificScenariosCard = ({
  scenario,
}: {
  scenario: ScenarioTemplateCompact
}) => {
  const scenarioPageLink = `${LINKS.SCENARIOS}/${scenario.key}`

  return (
    <li className={classes.item}>
      <ScenariosCard
        scenario={scenario}
        href={scenarioPageLink}
        isVertical
        className={classes.card}
      />
    </li>
  )
}
